<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <ProductsTable></ProductsTable>
  </Layout>
</template>

<script>
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import ProductsTable from '../components/products/productsTable.vue';
export default {
  components: { Layout, PageHeader, ProductsTable },
  data() {
    return {
      title: 'Products',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'products',
          href: '/production/products',
          active: true,
        },
      ],
    };
  },
};
</script>
<style scoped></style>
